/* eslint-disable */
import MobxReactForm from 'mobx-react-form';
import validatorjs from 'validatorjs';
import dvr from 'mobx-react-form/lib/validators/DVR';
import _set from 'lodash/set';
import ProfileState from '../../../../../../stores/ProfileStore';
import NotificationStore from '../../../../../../stores/NotificationStore';
import { PHONE_PREFIXES, PHONE_PREFIX_DEFAULT } from 'framework/constants/forms';
import i18next from 'i18next';
const t = (key, options) => i18next.t(key, options);
export const fields = [
    {
        name: 'firstName',
        label: 'CheckoutPage:contactInformation:fieldLabels.firstName',
        rules: 'required|string|firstName',
        value: ''
    },
    {
        name: 'lastName',
        label: 'CheckoutPage:contactInformation:fieldLabels.lastName',
        rules: 'required|string|lastName',
        value: ''
    },
    {
        name: 'email',
        type: 'email',
        label: 'CheckoutPage:contactInformation:fieldLabels.email',
        rules: 'required|email',
        value: ''
    },
    {
        name: 'phoneMain',
        label: 'CheckoutPage:contactInformation:fieldLabels.countryCode',
        fields: [
            {
                name: 'countryCode',
                label: 'CheckoutPage:contactInformation:fieldLabels.countryCode',
                type: 'string',
                rules: 'required',
                extra: PHONE_PREFIXES,
                value: PHONE_PREFIX_DEFAULT.value,
                observers: [{
                        key: 'value',
                        call: ({ form, change: { oldValue, newValue } }) => {
                            const regExp = /^(\+?\d{1,3}|\d{1,4})$/.test(newValue);
                            if (regExp || newValue === '+' || newValue === '') {
                                form.container().$('phoneMain.countryCode').set('value', newValue);
                            }
                            else {
                                form.container().$('phoneMain.countryCode').set('value', oldValue);
                            }
                        }
                    }],
                output: (data) => {
                    return data.value ? data.value : data;
                }
            },
            {
                name: 'areaCode',
                label: 'CheckoutPage:contactInformation:fieldLabels.areaCode',
                type: 'number',
                rules: 'required|phone_areaCode',
                value: ''
            },
            {
                name: 'phoneNumber',
                label: 'CheckoutPage:contactInformation:fieldLabels.phoneNumber',
                type: 'number',
                rules: 'required|phone_phoneNumber',
                value: ''
            }
        ],
        output: (value) => {
            const { countryCode, areaCode, phoneNumber } = value;
            return `${countryCode ? countryCode : ''}${areaCode}${phoneNumber}`;
        }
    },
    {
        name: 'birthday',
        label: 'CheckoutPage:contactInformation:fieldLabels.birthday',
        rules: 'required|dd/MM/yyyy',
        value: null
    },
    {
        name: 'street',
        label: 'CheckoutPage:contactInformation:fieldLabels.street',
        rules: 'required|string',
        value: ''
    },
    {
        name: 'number',
        label: 'CheckoutPage:contactInformation:fieldLabels.number',
        rules: 'required|string',
        value: ''
    },
    {
        name: 'zip',
        label: 'CheckoutPage:contactInformation:fieldLabels.zip',
        type: 'string',
        rules: 'required|postcode',
        value: '',
        observers: [{
                key: 'value',
                call: ({ form, change: { oldValue, newValue } }) => {
                    const regExp = /^\d{1,5}$/.test(newValue);
                    if (regExp || newValue === '') {
                        form.container().$('zip').set('value', newValue);
                    }
                    else {
                        form.container().$('zip').set('value', oldValue);
                    }
                }
            }]
    },
    {
        name: 'city',
        label: 'CheckoutPage:contactInformation:fieldLabels.city',
        rules: 'required|string',
        value: ''
    },
    {
        name: 'company',
        label: 'CheckoutPage:contactInformation:fieldLabels.company',
        value: ''
    }
];
const hooks = {
    onSuccess(form) {
        const { birthday, email, ...values } = form.values();
        const data = {
            birthday,
            privateAddress: {}
        };
        // Transform data back into profile service format
        Object.keys(values).forEach((parentField) => {
            _set(data.privateAddress, parentField, values[parentField]);
        });
        return ProfileState.updateUserProfileData(data)
            .then(() => {
            return ProfileState.getProfileData();
        })
            .catch((error) => {
            const { errors } = error;
            // TODO: Install jsonapi de-serialaizer and use it everywhere in app.
            // TODO: Move this part of code somewhere to the upper level of the abstraction
            if (errors) {
                errors.forEach((error) => {
                    if (error.status === '500') {
                        NotificationStore.addNotification({
                            message: t('Notifications:errors.validationError'),
                            level: 'error'
                        });
                        return;
                    }
                    const pointer = error.source && error.source.pointer;
                    const invalidationText = error.detail;
                    if (!pointer)
                        return;
                    const fieldName = pointer.split('/')[(pointer.split('/').length - 1)];
                    if (pointer.indexOf('privateAddress') >= 0) {
                        NotificationStore.addNotification({
                            message: `Contact Address ${fieldName} - ${invalidationText}`
                        });
                        form.$(`privateAddress.${fieldName}`).invalidate(invalidationText);
                    }
                    if (pointer.indexOf('deliveryAddress') >= 0) {
                        NotificationStore.addNotification({
                            message: `Delivery Address ${fieldName} - ${invalidationText}`
                        });
                        form.$(`deliveryAddress.${fieldName}`).invalidate(invalidationText);
                    }
                });
                return;
            }
            // TODO: handle jsonapi validation errors
            // when CORS issues fixed.
            // TODO: install some jsonapi client library
            NotificationStore.addNotification({
                message: t('Notifications:errors.validationError')
            });
        });
    },
    onError(form) {
        console.log('Form errors', form.errors());
    }
};
const plugins = {
    dvr: dvr({
        package: validatorjs
    })
};
const options = {
    validateOnChange: true
};
export default new MobxReactForm({ fields }, { plugins, hooks, options });
/* eslint-enable */
